module.exports = __webpack_public_path__ + "static/media/solar-panel.9c29b5d4.png";